module.exports = __webpack_public_path__ + "img/map3.fd208849.png";